import React, { useMemo } from 'react';
import InputComponent from '@ui/components/Input/Input.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    serverError,
    topic,
    topicError,
    content,
    contentError,
    onBtnKeyDown,
    onKeyDown,
    onKeyDownTextArea,
    onTopicChange,
    onContentChange,
    onSendClick,
    onInputClick,
    onClose,
}) => {
    const alertMessage = useMemo(() => {
        if (serverError) return 'serverError';
        else return '';
    }, [serverError]);

    return (
        <ModalComponent
            className="tech-support"
            title="techSupport"
            alertText={alertMessage}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onClose}
        >
            <ModalFormComponent>
                <InputComponent
                    label="topic"
                    name="topic"
                    type="text"
                    errorMessage="wrongTopic"
                    lang={lang}
                    value={topic}
                    error={topicError}
                    onChange={onTopicChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <InputComponent
                    label="content"
                    name="content"
                    type="text"
                    errorMessage="wrongContent"
                    multiline
                    lang={lang}
                    value={content}
                    error={contentError}
                    onChange={onContentChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="send"
                    lang={lang}
                    onClick={onSendClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="error"
                    label="cancel"
                    lang={lang}
                    onClick={onClose}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const TechSupportComponent = React.memo(Component);

export default TechSupportComponent;
